export default __webpack_public_path__ + "static/media/marke_5.e6fc9d8a.png";